import { render, staticRenderFns } from "./IndexClient.vue?vue&type=template&id=b7537a52&"
import script from "./IndexClient.vue?vue&type=script&lang=js&"
export * from "./IndexClient.vue?vue&type=script&lang=js&"
import style0 from "./IndexClient.vue?vue&type=style&index=0&id=b7537a52&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports